// extracted by mini-css-extract-plugin
export default {"pageContainer":"AllGroup_pageContainer__BUcay","createGroupModal":"AllGroup_createGroupModal__TMRbe"};